import {ngcAnimations} from '@app/core/comp/animations';
import {Component, Inject, Input, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialog as MatDialog,
    MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import {Claim} from '../announcement.service';

@Component({
    selector   : 'ngc-dialog-extinfo',
    templateUrl: './dialog-extinfo.component.html',
    styleUrls  : ['./dialog-extinfo.component.scss'],
    animations : ngcAnimations
})
export class DialogExtInfoComponent implements OnInit, OnDestroy {
    message: string;
    claim: Claim;


    constructor(
        public dialogRef: MatDialogRef<DialogExtInfoComponent>,
        public viewContainerRef: ViewContainerRef,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.message = this.data.message;
        this.claim = this.data.claim;
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {

    }

    result(res = ''): void {
        this.dialogRef.close(res);
    }
}
